import { render, staticRenderFns } from "./Interview_typesetting.vue?vue&type=template&id=20eb4dd7"
import script from "./Interview_typesetting.vue?vue&type=script&lang=js"
export * from "./Interview_typesetting.vue?vue&type=script&lang=js"
import style0 from "./Interview_typesetting.vue?vue&type=style&index=0&id=20eb4dd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports